import React, { forwardRef, useState } from 'react';
import { readOnlyAction, useAdminAccess } from 'contexts/adminAccess';
import { FieldProps, InjectedFieldProps } from 'react-admin';
import MenuItem from '@material-ui/core/MenuItem';

import { RewardedActionDto } from '../../types';
import EditActionDialog from './EditActionDialog';

type EditActionFieldProps = (FieldProps & InjectedFieldProps) & {
  record?: RewardedActionDto;
  onActionSaved?: (actionId: string, iconFile?: File) => void;
};

const EditActionField = forwardRef<HTMLLIElement, EditActionFieldProps>(
  ({ record, onActionSaved }, ref) => {
    const { canWrite } = useAdminAccess();
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
      <>
        <MenuItem ref={ref} onClick={handleOpen}>
          {canWrite ? 'Edit' : 'View'}
        </MenuItem>
        {open && (
          <EditActionDialog
            open={open}
            onClose={handleClose}
            action={record}
            onSaved={onActionSaved}
          />
        )}
      </>
    );
  }
);

export default readOnlyAction(EditActionField);
